import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledTooltipWrapper = styled.div`
    position: relative;
    width: 372px;
    min-width: 372px;
`;

export const StyledTooltipContentWrapper = styled(Flex)`
    padding: 24px 24px 16px;
`;
